import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { connectICloudCalendar, contactCalendarConnectionStatus, getCalendarOAuthUrl, getIndividualCalendarOAuthUrl, googleAuthenticate, revokeTokenForBusiness, revokeTokenForContact } from '@wix/ambassador-asa-calendar-oauth-v1-calendar-oauth/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { CalendarOAuthClientBase } from './CalendarOAuthClientBase';
export class CalendarOAuthClient extends HttpBaseClient(CalendarOAuthClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "revokeTokenForBusinessImpl", revokeTokenForBusiness);
    _defineProperty(this, "revokeTokenForContactImpl", revokeTokenForContact);
    _defineProperty(this, "contactCalendarConnectionStatusImpl", contactCalendarConnectionStatus);
    _defineProperty(this, "getCalendarOAuthUrlImpl", getCalendarOAuthUrl);
    _defineProperty(this, "getIndividualCalendarOAuthUrlImpl", getIndividualCalendarOAuthUrl);
    _defineProperty(this, "googleAuthenticateImpl", googleAuthenticate);
    _defineProperty(this, "connectICloudCalendarImpl", connectICloudCalendar);
  }
}
//# sourceMappingURL=CalendarOAuthClientHttp.js.map